<div [id]="backgroundImageId" class="bg-image shadow" color="primary" *ngIf="!isPasswordUpdate">
    <div class="mask d-flex align-items-center h-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-5 col-md-8">
            <form  action="submit" class="bg-white rounded shadow-5-strong p-4" [formGroup]="ResetPasswordForm">
              <div class="d-flex justify-content-center" >
                <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                  <img [src]="logoUrl" alt="IEA logo" class="logo" />
                </div>
              </div>
              
              <div class="col-12 text-center">
                <h2>Create New Password</h2>
                <p>For security purpose, your password must be at least 10 characters and include uppercase, numbers & special characters.</p>
                <hr />
              </div>
              <div class="example-container mt-3">
                <div class="row">
  
                  <div class="col-12">
                    <eq-password [label]="'Password'" [form]="ResetPasswordForm" [name]="'password'" [validators]="passwordValidator" class="mt-1" (onChange)="onFieldChange('password', $event)"></eq-password>
                  </div>
                  <div class="col-12">
                    <eq-password [label]="'Confirm your Password'" [form]="ResetPasswordForm" [name]="'confirmPassword'" [validators]="confirmPasswordValidator" class="mt-1" (onChange)="onFieldChange('confirmPassword', $event)"></eq-password>
                  </div>
                </div>
              </div>
  
              <button type="button" (click)="ResetPassword()" class="btn btn-primary btn-block w-100 py-3">
                Reset Password
              </button>

              <hr class="mt-4" />
              <div class="col-12 text-center mt-2">
                <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png" alt="IEA logo" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div id="intro" class="bg-image shadow" color="primary" *ngIf="isPasswordUpdate">
    <div class="mask d-flex align-items-center h-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-4 col-md-6">
            <form class="bg-white rounded shadow-5-strong p-4">
              <div class="d-flex justify-content-center" >
                <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                  <img [src]="logoUrl" alt="IEA logo" class="logo" />
                </div>
              </div>
              <div class="col-12 text-center">
                <!-- <img
                  src="../../../assets/images/access-logo-full.png"
                  alt="IEA logo"
                  class="logo"
                /> -->
                <h2> 
                  <mat-icon class="resetpassword-success-icon" matSuffix>check_circle</mat-icon>
                </h2> 
                <h3>Password Reset Successful!</h3>
                <p>
                  You can click below to sign in to your account.<br>
                </p>
                <hr />
              </div>
              
              <!-- Submit button -->
              <button type="button" (click)="signIn()" class="btn btn-primary btn-block w-100 py-3">
               Sign In
              </button>
  
              <div class="col-12 text-center mt-2">
                <img
                class="footer-logo"
                src="../../../assets/images/poweredby-OneEquineblack-logo.png"
                alt="IEA logo"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>